import React from "react";
import { Checkbox, FormControlLabel, FormControlLabelProps } from "@mui/material";
import { CSS_CLASS_NAME_CHECKBOX_ICON } from "./constants";

export interface ICheckboxWithLabelProps extends Omit<FormControlLabelProps, "control"> {
    checkboxProps?: React.ComponentProps<typeof Checkbox>;
}

export function CheckboxWithLabel({ checkboxProps, ...props }: ICheckboxWithLabelProps) {
    const isSmall = checkboxProps?.size === "small";
    return (
        <FormControlLabel
            control={<Checkbox {...checkboxProps} />}
            {...props}
            sx={{
                transition: "color 0.2s",
                margin: 0,
                [`&:hover:not(.Mui-disabled):not(.Mui-checked) .${CSS_CLASS_NAME_CHECKBOX_ICON}`]: {
                    borderColor: "var(--mui-palette-gray-800)",
                },

                [`&:hover:not(.Mui-disabled) .Mui-checked .${CSS_CLASS_NAME_CHECKBOX_ICON}`]: {
                    borderColor: "var(--mui-palette-gray-400)",
                },
                [`&.Mui-disabled:hover`]: {
                    cursor: "not-allowed",
                },
                "& .MuiFormControlLabel-label": {
                    paddingLeft: 1,
                    fontSize: isSmall ? "14px" : undefined,
                },
                ...props.sx,
            }}
        />
    );
}
